import { PeeringsCountSubscription } from "../../graphql/generated/operations";

/**
 * @param {PeeringsCountSubscription | undefined} data
 * @returns {number | undefined}
 */
export const formatter = (data) => data?.peeringsAggregate.aggregate?.count;
